<template>
<b-modal id="calibrationModal" title="Calibrate Device" size="lg" :no-close-on-backdrop="true" header-bg-variant="dark" header-text-variant="light" body-bg-variant="light"  :no-fade="true">
  <b-container fluid v-if="device">
      <h4 class="card-title">{{ device.product_serial_num }}</h4>
      <p class="card-text"><strong>Circuit: </strong><span v-if="device && device.pole">{{device.pole.circuit_name}}</span><span v-else>N/A</span></p>
    <br />
  </b-container>
    <template #modal-footer>
        <b-button variant="primary" @click="calibrateDevicePressed">
        Calibrate Device
        </b-button>
        <b-button variant="outline-secondary" @click="$bvModal.hide('calibrationModal')">
        Close
        </b-button>
    </template>
  
</b-modal>
</template>
<script>
import { deviceService } from "@/_services";
export default {
  name: "CalibrationModal",
  props: {
    device: {
      type: Object
    },
  },
  data() {
    return {
    };
  },
  methods: {
    async calibrateDevicePressed() {
      if (!this.device) return;
      try {
        await deviceService.calibrateDevice(this.device);
        this.$bvToast.toast('Device calibrated successfully', {
          title: 'Success',
          variant: 'success',
          solid: true
        });
        this.$bvModal.hide('calibrationModal');
      } catch (err) {
        console.error(err);
        this.$bvToast.toast('Failed to calibrate device', {
          title: 'Error',
          variant: 'danger',
          solid: true
        });
      }
    },
  },
  computed: {
  },
  mounted() {
   
  }
};
</script>